export default {"src":"/_next/static/media/safeIcon.96a18927.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};